import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../utils/constants';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http: HttpClient) { }

  // Sends via Graph delegated /me/sendMail, so the mail is sent from the currently logged-in account
  sendMail(recipients: string[], subject: string, body: string): Observable<void> {
    const url = `${Constants.GRAPH_ENDPOINT}/me/sendMail`;
    const payload = {
      message: {
        subject,
        body: {
          contentType: 'HTML',
          content: body
        },
        toRecipients: recipients.map(address => ({ emailAddress: { address } }))
      },
      saveToSentItems: true
    };
    return this.http.post<void>(url, payload);
  }
}
